var _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 20,
    viewBox: "0 0 47 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 35,
    height: 2,
    rx: 1,
    fill: "url(#paint0_linear_1508_5483)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 47,
    height: 2,
    rx: 1,
    fill: "url(#paint1_linear_1508_5483)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 41,
    height: 2,
    rx: 1,
    fill: "url(#paint2_linear_1508_5483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1508_5483",
    x1: 12.3723,
    y1: 1.1,
    x2: 18.1445,
    y2: -12.2728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6547D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA36B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1508_5483",
    x1: 0.5,
    y1: 10.1,
    x2: 5.12173,
    y2: -4.27873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6547D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA36B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1508_5483",
    x1: 6.43617,
    y1: 19.1,
    x2: 11.5829,
    y2: 5.13211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6547D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA36B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2fc4384f1e6e589c48beccaf9f775ee0.svg";
export { ForwardRef as ReactComponent };